import React from 'react';
import { useRouter, usePathname } from 'next/navigation';
import { useBannerAssets } from '@/shared/hooks/useBannerAssets';
import { ResponsiveBannerImage } from '@/shared/ui/responsive-banner-image';
import { BannerStyle } from './styles';

export const BonusRegisterBanner = () => {
  const pathname = usePathname();
  const isBonusesInfoPage = pathname.includes('/bonuses/info');
  const bannerAssets = useBannerAssets('bonusesBanner');
  const router = useRouter();

  const getBannerAsset = (asset: string) => {
    if (isBonusesInfoPage) {
      return asset.replace(/\.(\w+)$/, '-noBtn.$1');
    }
    return asset;
  };

  const handleBoxClick = () => {
    if (!isBonusesInfoPage) {
      router.push('/bonuses/info');
    }
  };

  if (!bannerAssets) {
    return null;
  }

  return (
    <BannerStyle onClick={handleBoxClick}>
      <ResponsiveBannerImage
        desktopSrc={getBannerAsset(bannerAssets.default)}
        mobileSrc={getBannerAsset(bannerAssets.mobile)}
        alt="Registration bonus"
        fetchPriority="high"
      />
    </BannerStyle>
  );
};
